import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorHandling } from './app/components/common/ErrorHandling';
import Routes from './app/Routes';
import { AuthContextProvider } from './store/AuthContext'
import { UserContextProvider } from './store/UserContext';
// ErrorHandling.init();

ReactDOM.render(
  <AuthContextProvider>
    <UserContextProvider>
      <React.StrictMode>
        <Routes />
      </React.StrictMode>
    </UserContextProvider>
  </AuthContextProvider>,
  document.getElementById('root'),
);
